<template lang="pug">
  .modal.fixed.top-0.left-0.right-0.h-screen.blur-bg.z-40.flex.flex-col.items-center.pt-32.overflow-scroll(class="sm:justify-end")
    .absolute.top-0.left-0.right-0.bottom-0(@click="$emit('close')")
    slot.flex-shrink-0.pb-32(@done="$emit('close')")
</template>

<script>
import { mapGetters } from "vuex";
import { ref, computed } from "@vue/composition-api";

export default {
  props: ["objective", "index"],
  computed: {
    ...mapGetters(["company"])
  },
  setup(props, { root }) {}
};
</script>

<style lang="sass" scoped></style>
